import { SchemaModelFieldType, TableResourceType } from '@smx-ui-model/types';
import { Form, Input } from 'antd';
import * as React from 'react';
import { memo } from 'react';

interface FieldStringProps {
    field: SchemaModelFieldType;
    entity: TableResourceType;
}

export const FieldString: React.FC<FieldStringProps> = ({ field, entity }) => {
    const rules = [];

    if (field.isRequired) {
        rules.push({
            required: true,
            message: 'Please input data!',
        });
    }

    return (
        <Form.Item label={field.title} name={field.name} rules={rules}>
            <Input disabled={field.isReadonly && !!entity} />
        </Form.Item>
    );
};

export default memo(FieldString);
